export const DEFAULT_VALUE = 'DEFAULT_VALUE';
export const BUSINESS_CHAT_SUB_TYPE = 'business_chat_added';
export const PRO_PAYMENT_WAY_SUB_TYPE = 'pro_payment_way';

export const SUPPORT_CHAT_INIT_EVENT_NAME = 'supportchat:init';
